module.exports = __webpack_public_path__ + "img/user-needs.122ff89e.svg";